import React, { Component } from "react";

import Header from "../components/Header_footer/Header";
import Footer from "../components/Header_footer/Footer";
import SideNavbar from "../components/Header_footer/Header/SideNavbar";
import { isMobile } from 'react-device-detect';
import axios from 'axios';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { clearSession } from "../redux/actions/session_actions";
class Layout extends Component {

  componentDidMount() {
    // Axios interceptors are functions that execute for every HTTP request or response within an Axios instance.
    // They act as middleware, allowing us to modify requests before they're sent and responses before they're handled by our application. 
    // This provides a centralized way to handle tasks like authentication, error handling, and logging, making your code cleaner and more efficient. 

    axios.interceptors.response.use(
      (response) => {
        // Handle successful responses globally
        console.log('Global_API_Response_SUCCESS', response.data);

        if (response.data.status === "SESSION_OVER") {
          this.props.dispatch(clearSession())
          this.props.history.push("/session-over")
        }
        else {
          return response;
        }
      },
      (error) => {
        // Handle errors globally
        console.error('Global_API_Response_ERROR', error);
        return Promise.reject(error);
      }
    );
  }

  render() {
    return (
      <div>

        <div className="outer-container">

          <Header />

          <div style={{ display: !isMobile ? 'flex' : "", height: "100%", width: "100%" }}>
            <SideNavbar />

            {/*Route Based Components*/}
            {this.props.children}

          </div>

          {isMobile &&
            !this.props.hideHeader &&
            !this.props.hideFooter &&
            <Footer />
          }

        </div>

      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    bankAccountResponse: state.bankAccountResponse,
    hideHeader: state.commonActionsReducer.hideHeader,
    hideFooter: state.commonActionsReducer.hideFooter
  };
};


export default connect(mapStateToProps)(withRouter(Layout));
